import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiClock, FiGift, FiTruck } from "react-icons/fi";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/delivery.scss";

function Delivery() {
  useEffect(() => {
    document.title = `Shipping | ${siteConfig.displayName}`;
  }, []);

  return (
    <main className="care-page shipping-page">
      <nav className="care-tabs" aria-label="Customer care">
        <Link to="/contact">Contact</Link>
        <Link className="is-active" to="/shipping">Shipping</Link>
        <Link to="/returns">Returns</Link>
        <Link to="/shipping#payment-options">Payment options</Link>
      </nav>
      <header className="care-heading">
        <p className="eyebrow">CUSTOMER CARE</p>
        <h1>Shipping</h1>
        <p>From our collection to your door, with clear timing and tracking.</p>
      </header>

      <section className="care-highlights">
        <article><FiTruck /><strong>Tracked delivery</strong><span>tracked from dispatch</span></article>
        <article><FiClock /><strong>6–12 business days</strong><span>standard US delivery</span></article>
        <article><FiGift /><strong>Complimentary over {formatPrice(siteConfig.freeShippingThreshold)}</strong><span>automatically applied</span></article>
      </section>

      <div className="care-columns">
        <section>
          <h2>Delivery methods</h2>
          <div className="shipping-table">
            <div><strong>Standard delivery</strong><span>6–12 business days</span><b>{formatPrice(siteConfig.standardShipping)}</b></div>
            <div><strong>Express delivery</strong><span>2–4 business days</span><b>{formatPrice(35)}</b></div>
          </div>
          <p>
            Standard shipping becomes complimentary when the merchandise subtotal
            reaches {formatPrice(siteConfig.freeShippingThreshold)} after discounts.
          </p>
        </section>
        <section>
          <h2>Tracking your order</h2>
          <p>
            When an order leaves the warehouse, a dispatch confirmation includes a
            carrier tracking link. Tracking can take up to 24 hours to show movement.
          </p>
          <h2>Duties and delivery changes</h2>
          <p>
            US prices are shown in dollars. Final taxes are confirmed at checkout.
            For security, the delivery address cannot be changed after dispatch.
          </p>
          <h2 id="payment-options">Payment options</h2>
          <p>
            Available payment methods are shown at checkout. Payment authorization
            is handled securely by the selected provider.
          </p>
          <p>For delivery questions, <Link to="/contact">contact our team</Link>.</p>
        </section>
      </div>
    </main>
  );
}

export default Delivery;
